import { render, staticRenderFns } from "./LogAlteracoesTimeline.vue?vue&type=template&id=23ac290f&scoped=true"
import script from "./LogAlteracoesTimeline.vue?vue&type=script&lang=js"
export * from "./LogAlteracoesTimeline.vue?vue&type=script&lang=js"
import style0 from "./LogAlteracoesTimeline.vue?vue&type=style&index=0&id=23ac290f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac290f",
  null
  
)

export default component.exports